import { defaultTo, is, map, pipe, when } from "ramda";

const cleanBrokerRelationshipsFromForm = (clientForm) => {
  const brokers = clientForm.broker || [];

  const cleanBrokers = brokers.filter((b) => b.brokerId);

  return {
    ...clientForm,
    broker: cleanBrokers,
  };
};

const makeOptions = pipe(
  when(
    is(Array),
    map((b) => ({
      value: b.brokerId,
      text: b.fullName,
    }))
  ),
  defaultTo([])
);

export {
  makeOptions,
  cleanBrokerRelationshipsFromForm,
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client-form/basic-client-sections/associatedBrokers.js